import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { Service } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromServices from './services.actions';
import { ServicesState } from './services.interfaces';
import { map } from 'rxjs/operators';
@Injectable()
export class ServicesEffects {
  
  getServicesFromServer = createEffect(() => this.dataPersistence.fetch(fromServices.GET_SERVICES_FROM_SERVER, {
    run: (action: fromServices.GetServicesFromServer, state: ServicesState) => {
      return this.apiService
        .get<Service[]>(`v/1/fixed-operations/services`, {
          params: action.payload
        })
        .pipe(
          map(
            services =>
              new fromServices.GetServicesFromServerSuccess({
                services: services
              })
          )
        );
    },
    onError: (action: fromServices.GetServicesFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ServicesState>,
    private apiService: ApiService
  ) {}
}
